export const RequiredInput = () => {
  return <span className="text-red-500 pl-1">*</span>;
};
